import { Printer } from "@phosphor-icons/react";

export default function DrugTestConsentPage() {
  return (
    <div className="min-h-screen bg-stone-100 py-10" data-testid="drug-consent-page">
      <div className="mx-auto max-w-2xl rounded-xl border border-stone-200 bg-white p-8 shadow-sm print:border-0 print:shadow-none">
        <div className="flex items-center justify-between gap-3 print:hidden">
          <img src="/shc-logo.png" alt="Silver Home Care" className="h-12 w-auto" />
          <button onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-white hover:bg-stone-900"
            data-testid="drug-consent-print">
            <Printer size={14} /> Print
          </button>
        </div>
        <h1 className="mt-6 font-heading text-2xl font-bold text-stone-900">Drug Testing Consent Form</h1>
        <p className="mt-1 text-xs text-stone-500">Silver Home Care · 680 Lincoln Hwy, Fairless Hills, PA 19030 · 800-719-6912</p>

        <div className="mt-6 space-y-4 text-sm leading-relaxed text-stone-700">
          <p>
            Silver Home Care is committed to a safe, reliable environment for the people we serve. As a condition of
            employment, all applicants and employees are subject to drug and alcohol screening as described below.
          </p>
          <div className="rounded-lg border border-stone-200 bg-accent/30 p-4">
            <p className="text-xs font-semibold uppercase tracking-wide text-stone-500">Pre-employment screening</p>
            <p className="mt-1">I agree to submit to a urine test or oral swab test to screen for the use of controlled substances as a condition of employment.</p>
          </div>
          <div className="rounded-lg border border-stone-200 bg-accent/30 p-4">
            <p className="text-xs font-semibold uppercase tracking-wide text-stone-500">Accident / incident testing</p>
            <p className="mt-1">I agree to submit to a drug and alcohol test in the event that I am involved in a workplace accident or incident.</p>
          </div>
          <p>
            I understand that a confirmed positive result, or refusal to test, may result in the withdrawal of a
            conditional offer or in dismissal, consistent with applicable law. Test results are kept confidential to
            the extent permitted by law.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-8 text-xs text-stone-600">
          <div className="border-t border-stone-400 pt-1.5">Applicant signature</div>
          <div className="border-t border-stone-400 pt-1.5">Date</div>
          <div className="border-t border-stone-400 pt-1.5">Printed name</div>
          <div className="border-t border-stone-400 pt-1.5">Witness (Silver Home Care)</div>
        </div>
        <p className="mt-8 text-[11px] leading-relaxed text-stone-400">
          This consent is also acknowledged electronically as part of the Silver Home Care employment application.
          Questions? Call the office at 800-719-6912.
        </p>
      </div>
    </div>
  );
}
